<template>
  <footer>
    <div class="main">
      <p>Schilderwerken Munsterman</p>
    </div>
  </footer>
</template>
<script>
export default {
  name: 'AppFooter',
};
</script>
<style lang="scss" scoped>
@import '../assets/css/definitions.scss';
  footer {
    flex-shrink: 0;
    width: 100%;
    background: $color-bg;
    color: black;

    .main {
      // display: flex;
      // flex-direction: row;
      padding: 16px 50px;
      text-align: center;
      font-size: 1.25rem;
    }
  }
</style>
